import type { SupportTicketId } from "@redotech/effect-api-shared/ids/definitions";
import type { MongoUserId } from "@redotech/effect-api-shared/ids/mongo-ids";
import { RedoBadge } from "@redotech/redo-web/arbiter-components/badge/redo-badge";
import { RedoListDropdown } from "@redotech/redo-web/arbiter-components/list/redo-list-dropdown";
import { Flex } from "@redotech/redo-web/flex";
import { memo } from "react";
import { useAssigneeSelector } from "../hooks/use-assignee-selector";
import { FieldLabel } from "./field-label";

export const AssigneeSelector = memo(function AssigneeSelector({
  supportTicketId,
  mongoAssigneeId,
}: {
  supportTicketId: SupportTicketId;
  mongoAssigneeId: MongoUserId | null;
}) {
  const {
    assigneeListItems,
    selectedItem,
    canEditAssignee,
    badgeText,
    badgeAvatar,
    dropdownOpen,
    badgeRef,
    setBadgeRef,
    handleBadgeClick,
    handleDropdownOpenChange,
    handleItemSelected,
    searchText,
    setSearchText,
  } = useAssigneeSelector({ supportTicketId, mongoAssigneeId });

  return (
    <Flex align="center" gap="xs" justify="space-between">
      <FieldLabel>Assignee</FieldLabel>
      <Flex
        onClick={handleBadgeClick}
        style={{ cursor: canEditAssignee ? "pointer" : "default" }}
      >
        <RedoBadge
          avatar={badgeAvatar}
          color="gray"
          setRef={setBadgeRef}
          shadow
          size="sm"
          text={mongoAssigneeId ? badgeText : "+"}
        />
      </Flex>
      <RedoListDropdown
        dropdownAnchor={badgeRef}
        dropdownOpen={dropdownOpen}
        items={assigneeListItems}
        itemSelected={({ item }) => handleItemSelected(item.value)}
        searchPlaceholder="Search for an option..."
        searchString={searchText}
        selectedItems={selectedItem?.id}
        setDropdownOpen={handleDropdownOpenChange}
        setSearchString={setSearchText}
        size="xs"
      />
    </Flex>
  );
});
